(function DetailsContextMenuLambda(global) {

  /*
  * Пункт меню  
  */
  var ITEM = {
    ADD: 1,
    COPY: 2,
    DELETE: 3
  };

  /*
  * Имя реквизита "Номер строки"  
  */
  var ROW_NUMBER = {
    VALUE: L('DETAIL_REQ_NUMBER'),
    DISPLAY_VALUE: 'Field_' + L('DETAIL_REQ_NUMBER')
  };

  /**
  * Контекстное меню для грида
  * @class Core.grid.DetailsContextMenu
  * @extends BaseObject
  */
  global.DetailsContextMenu = BaseObject.extend({
    _sectionNumber: null,
    _grid: null,
    _form: null,
    _clickedCell: 1,
    _clickedInContextMenu: false, //что бы событие addRow и выделение активной ячейки срабатывало только при вызове контекстного меню.

    init: function (dfmName) {
      var me = this;
      me._dfmName = dfmName;

      me._clickedCell = 1;
      me._clickedInContextMenu = false;

    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    setGrid: function (grid) {
      this._grid = grid;
    },

    setForm: function (form) {
      this._form = form;
    },

    /**
    * Создание настроек для пунктов меню
    * @method Core.grid.DetailsContextMenu#generateItems
    */
    generateItems: function (event) {
      var me = this;
      var rowId = me._getRowIdFromEvent(event);
      var isTableDisabled = this._grid._table.isDisabled();

      var item = function (id, label, icon, opt_disabled) {
        return {
          "name": id,
          "label": L(label),
          "icon": icon,
          "bottomSeparator": false,
          "disabled": false || opt_disabled
        }
      };
      return [
          item(ITEM.ADD, 'ADD', 'cardCreate-16', !me._canAddNewRow() || isTableDisabled),
          item(ITEM.COPY, 'COPY', 'cardCopy-16', !rowId || !me._canCopyRow(rowId) || isTableDisabled),
          item(ITEM.DELETE, 'DELETE', 'delete-16', !rowId || isTableDisabled)
      ]
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Навесить обработчки на меню и свзяать их с гридом
    * @method Core.grid.DetailsContextMenu#generateSettings
    */
    bindActionsToMenuItems: function (menu, ev, grid) {
      var me = this;
      me._grid = grid;

      me._clickedCell = me._getCellNumberFromEvent(ev);
      me._clickedInContextMenu = true;

      var table = me._grid._table;
      //TODO Шамов А.: Оптимизировать, т.к. точно такое же есть в EditPlugin.js.
      table.bind('addRow', function (row) {
        if (me._clickedInContextMenu) {
          log.info('DETAILGRID', 'addRow in DetailsContextMenu');
          var grid = table._grid;
          var editor = grid.grid.getCellEditor();
          if (!!editor) {
            // Вызываем сохранение выбранного значения в текущем редакторе, что бы оно ушло в datasource и потом сохранилось в БД (замечание №103950).
            editor.commit();
          }
          setTimeout(function () {
            // Смещаем фокус на новую строку в ту же ячейку что и на предыдущей (замечание №103371).
            grid.grid.setActiveCell(grid.grid.getDataLength() - 1, me._clickedCell);
            grid.grid.editActiveCell();
            me._clickedInContextMenu = false;
          }, 100);
        }
      });

      menu.bind('itemSelect', function (item, menu, event) {
        var rowId = me._getRowIdFromEvent(event);

        switch (item.name) {
          case ITEM.ADD:
            me.addRow();
            break
          case ITEM.COPY:
            if (!rowId) return;
            me.copyRow(rowId);
            break
          case ITEM.DELETE:
            if (!rowId) return;
            me.deleteRow(rowId);
            break
        }
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавление новой строки    
    * @method Core.grid.DetailsContextMenu#addRow    
    */
    addRow: function () {
      if (this._canAddNewRow()) {
        this._grid._table.addRow();
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**    
    * Копирование строки.    
    * @method Core.grid.DetailsContextMenu#copyRow    
    * @param {integer} rowId ид строки
    */
    copyRow: function (id) {
      var me = this;
      var row, rows, reqArray;

      var currTable = me._grid._table;
      var detailNum = currTable.detailNum;
      var tablesArr = me._form.details[detailNum].getTables().toArray(); //FIXME: Хз, что делать

      // Сначала удаляем пустую строку, если она есть.
      var rowsArr = currTable.rows.toArray();
      for (var i = 0; i < rowsArr.length; i++) {
        row = rowsArr[i];
        if (row.isNew() && !row.isChanged()) {
          row.remove();
        }
      }

      // Проверить наличие колонок с CanGUIRead = true. Если такие имеются, то в них содержатся
      // "*", а не корректные данные
      var currentTableColumns = currTable.columns;
      var hasColumnWithDisabledGuiChange = currentTableColumns.toArray().some(function (column) {
        return !column.getCanGUIRead();
      });

      // Собираем реквизиты со всех вкладок.
      var requisites = {};
      for (var t = 0; t < tablesArr.length; t++) {
        rows = tablesArr[t].rows;
        row = rows[id];
        if (row) {
          reqArray = row.requisites.toArray();

          // Создадим словарь
          $.extend(requisites, _.chain(reqArray)
            .filter(function (req) {
              var currentColumn = currentTableColumns[req.name];
              return !req.isSystem() && currentColumn.getCanGUIRead() && currentColumn.isVisible();
            })
            .map(function (item) {
              return [item.name, {
                value: item.getValue(),
                displayValue: item.getDisplayValue(),
                needTriggerResult: true
              }]
            }).object().value());
        }
      }

      // Если детальный раздел только один, то копируем на клиенте, иначе копируем на сервере (замечание №104110).
      if (tablesArr.length === 1 && !hasColumnWithDisabledGuiChange) {
        // Копируем строку.
        this._grid._table.addRow(requisites, function (row) {
          reqArray = row.requisites.toArray();
          _(reqArray).each(function (req) {
            req.touch(); //Если так не делать, то после копирования невозможно будет добавить новую строку
          })
        });

      } else {
        // Копируем строку на сервере (замечание №104110).
        this._grid._table.copyRowOnServer(id, requisites, function (row) {
          reqArray = row.requisites.toArray();
          _(reqArray).each(function (req) {
            req.touch(); //Если так не делать, то после копирования невозможно будет добавить новую строку
          })
        });
      }

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Удаление строки
    * @method Core.grid.DetailsContextMenu#deleteRow
    * @param {integer} rowId ид строки
    */
    deleteRow: function (rowId) {
      this._grid._table.deleteRow(rowId);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить ид-строки над которой было вызвано контекстное меню
    * @method Core.grid.DetailsContextMenu#_getRowIdFromEvent
    * @private
    * @return {integer}
    */
    _getRowIdFromEvent: function (event) {
      var target = event.target || event.srcElement;
      var jRow = $(target).parents('div.slick-row');
      var rowId = jRow.attr('id');
      return rowId;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить номер колонки над которой было вызвано контекстное меню
    * @method Core.grid.DetailsContextMenu#_getRowIdFromEvent
    * @private
    * @return {integer}
    */
    _getCellNumberFromEvent: function (event) {
      var target = $(event.target || event.srcElement);
      var jCell;
      if (target.hasClass('slick-cell')) {
        jCell = target;
      } else {
        jCell = target.parents('.slick-cell:first');
      }
      return jCell.index();
    },

    /**
    * Проверка возможности копирования строки
    * @method Core.grid.DetailsContextMenu#_canCopyRow
    * @private
    * @return {boolean}
    */
    _canCopyRow: function (rowId) {
      var row = this._grid._table.rows[rowId];
      if (row.hasFilledRequisites()) {
        return true;
      } else {
        return false;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверка возможности добавления новой строки
    * @method Core.grid.DetailsContextMenu#_canAddNewRow
    * @private
    * @return {boolean}
    */
    _canAddNewRow: function () {
      var table = this._grid._table;
      var rows = table.rows.toArray();

      if (rows.length) {
        var lastRow = rows[rows.length - 1];
        if (lastRow.hasFilledRequisites()) {
          return true;
        } else {
          return false;
        }
      } else {
        return true
      }
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

})(window.WA.components.dataViews.gridPlugins);